import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"palette"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 11.4638C21.8602 13.5427 20.4781 15.0907 18.2745 15.6853C16.4138 16.1874 14.3189 15.1872 12.8831 16.3886C11.4474 17.5899 11.6818 19.0549 12.3264 20.0805C12.7454 20.747 13.5078 21.8971 11.6525 21.8971C6.12965 21.8971 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22.3705 5.95339 22 11.4638Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M11.75 8.00391C11.1977 8.00391 10.75 7.55619 10.75 7.00391C10.75 6.45162 11.1977 6.00391 11.75 6.00391C12.3023 6.00391 12.75 6.45162 12.75 7.00391C12.75 7.55619 12.3023 8.00391 11.75 8.00391Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M7.0293 11.0039C6.47701 11.0039 6.0293 10.5562 6.0293 10.0039C6.0293 9.45162 6.47701 9.00391 7.0293 9.00391C7.58158 9.00391 8.0293 9.45162 8.0293 10.0039C8.0293 10.5562 7.58158 11.0039 7.0293 11.0039Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M16.5176 11.0039C15.9653 11.0039 15.5176 10.5562 15.5176 10.0039C15.5176 9.45162 15.9653 9.00391 16.5176 9.00391C17.0699 9.00391 17.5176 9.45162 17.5176 10.0039C17.5176 10.5562 17.0699 11.0039 16.5176 11.0039Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 11.4638C21.8602 13.5427 20.4781 15.0907 18.2745 15.6853C16.4138 16.1874 14.3189 15.1872 12.8831 16.3886C11.4474 17.5899 11.6818 19.0549 12.3264 20.0805C12.7454 20.747 13.5078 21.8971 11.6525 21.8971C6.12965 21.8971 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22.3705 5.95339 22 11.4638Z","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M11.75 8.00391C11.1977 8.00391 10.75 7.55619 10.75 7.00391C10.75 6.45162 11.1977 6.00391 11.75 6.00391C12.3023 6.00391 12.75 6.45162 12.75 7.00391C12.75 7.55619 12.3023 8.00391 11.75 8.00391Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M7.0293 11.0039C6.47701 11.0039 6.0293 10.5562 6.0293 10.0039C6.0293 9.45162 6.47701 9.00391 7.0293 9.00391C7.58158 9.00391 8.0293 9.45162 8.0293 10.0039C8.0293 10.5562 7.58158 11.0039 7.0293 11.0039Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M16.5176 11.0039C15.9653 11.0039 15.5176 10.5562 15.5176 10.0039C15.5176 9.45162 15.9653 9.00391 16.5176 9.00391C17.0699 9.00391 17.5176 9.45162 17.5176 10.0039C17.5176 10.5562 17.0699 11.0039 16.5176 11.0039Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const Palette = Vue.extend<IconProps>({
  name: 'PaletteIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'palette',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Palette;
